import React from "react";
import { Typography } from "@mui/material";
import { Container } from "@mui/system";
import { Button } from '@mui/material';


function Tutoring() {
  return (
    <Container>
      {/*<Typography variant='p' mt={3}>
        <span style={{ fontWeight: 'bold', color: 'white' }}>IMPORTANT: </span>
        While classes are online (currently Week 6 Wednesday through Friday), tutoring will be held on Zoom!
      </Typography>
      <Box
        sx={{
          backgroundColor: 'black',
          borderRadius: '12px',
          display: 'inline-block',
        }}
        p={2}
        mt={2}
      >
        <Typography variant='p' color='white'>
          Zoom:{' '}
          <a href='https://ucla.zoom.us/j/92285065964'>
            https://ucla.zoom.us/j/92285065964
          </a>
        </Typography>
        <Typography variant='p' color='white'>
          Meeting ID: 922 8506 5964
        </Typography>
      </Box>
      */}

      <Typography variant="h1" mt={10} mb={"20px"}>
            Tutoring
      </Typography>
      <Typography variant="p" mb={"20px"}>
            We offer free drop-in tutoring in all STEM courses at our office
            (Boelter 6266). Feel free to stop by for homework help or pre-exam
            practice. Please check the schedule below for course availability.
      </Typography>
      <Typography variant="p" mb={"20px"}>
            Hours: Mon-Fri, 10 am - 4 pm, Weeks 3 - 9
      </Typography>

      <Typography variant="p" mt={2}>
        Direct any questions or concerns to TBP's tutoring chairs at{" "}
        <a href="mailto:uclatbp.tutoring@gmail.com">
          uclatbp.tutoring@gmail.com
        </a>
        . The schedule is subject to change.
        <br></br>
        Have additional questions outside of normal tutoring hours? Join our new{" "}
        <a href="http://bit.ly/TBPCampuswire"> TBP Tutoring Campuswire</a> with
        code 4268 to get help!
        <br></br>
        <br></br>
        <b>Location:</b>
        <br />
        Boelter 6266S <br />
        <br></br>
        <b>Hours:</b>
        <br />
        Monday through Friday
        <br />
        10AM - 4PM PST
        <br />
        Weeks 3 through 9<br />
      </Typography>
      
      {/*<Typography variant='p' mt={5}>
        Our tutoring starts <Typography variant='highlight'> Week 3</Typography>
        . Check back later for this quarter's schedule!
      </Typography>*/}
      <br></br>
      <iframe
        title="tutoringSchedule"
        src="https://docs.google.com/spreadsheets/d/e/2PACX-1vRtsWc9kdurxcpQMTt7WlQmoaAqLEhCxLDDWODWRCo3tLkFVmAwcWvac1G6F0NmVUdP_WvHA8Gix2pN/pubhtml#gid=961529905&amp;single=true&amp;widget=true&amp;headers=false"
        width="105%"
        height="900"
        frameBorder="0"
      ></iframe>
          {/* <h1 className='header'>Tutoring</h1> */}
          {/*<Typography variant='p' mb={'20px'}>
            Tutoring will be on Zoom at the following link while classes are online:
            <br></br>
            <a href='https://ucla.zoom.us/j/92285065964'>
              https://ucla.zoom.us/j/92285065964
            </a>
        </Typography>*/}



            {/* <Grid item>
              <Button
                href='tutoring/reviewsheets/'
                color='secondary'
                variant='outlined'
                size='large'
              >
                REVIEW SHEETS
              </Button>
            </Grid> */}


              <center><Button
                href="https://forms.gle/sburNuSv83ekaTTf8"
                color="secondary"
                variant="outlined"
                size="large"
              >
                TUTORING FEEDBACK
              </Button>
              </center>
              <br></br>
              <br></br>
              <br></br>

            {/* <Grid item>
              <Button
                href='/tutoring/log_hours/'
                color='secondary'
                variant='outlined'
                size='large'
              >
                LOG HOURS
              </Button>
            </Grid> */}

    </Container>
    
  );
}

export default Tutoring;
